import {
  ALLOWED_IMAGE_TYPES,
  MAX_FILE_SIZE,
} from '../constants/draft.constants';
import ErrorMessages from '../constants/error-messages';

export const UPLOAD_ERRORS = {
  ...ErrorMessages.PRE_SIGNED_URL_ERRORS,
  FILE_TOO_LARGE: 'Image exceeds the maximum size of 3MB',
  INVALID_FILE_TYPE:
    'Invalid file type. Only JPEG, PNG, GIF, and WEBP are allowed',
  UPLOAD_FAILED: 'Failed to upload image',
};
/**
 * Validates an image file
 * @param file The file to validate
 * @returns An object containing validation result and error message if any
 */
export const validateImageFile = (
  file: File,
): { isValid: boolean; error?: string } => {
  if (!file) {
    return { isValid: false, error: UPLOAD_ERRORS.SELECT_FILE };
  }

  if (file.size > MAX_FILE_SIZE) {
    return { isValid: false, error: UPLOAD_ERRORS.FILE_TOO_LARGE };
  }

  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return { isValid: false, error: UPLOAD_ERRORS.INVALID_FILE_TYPE };
  }

  return { isValid: true };
};
